var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConcession(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 120,
    viewBox: "0 0 118 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M113.054 81.0697C101.606 108.227 71.1097 123.441 44.6631 119.337C40.3596 118.669 28.5621 116.68 18.1165 107.296C-1.9913 89.2299 -6.29177 53.4573 9.92882 28.2476C21.7345 9.8992 42.8972 -0.501525 63.0059 0.0186207C67.3372 0.1308 83.9371 0.821405 98.5257 12.9403C100.668 14.7203 105.395 18.9503 109.654 25.6604C119.655 41.4177 120.515 63.3708 113.054 81.0697H113.054Z",
    fill: "#0095DF",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0004 4.4502H109.677V26.5002C109.677 26.8343 109.406 27.1056 109.072 27.1056H83.6053C83.2713 27.1056 83 26.8343 83 26.5002V4.4502H83.0004Z",
    fill: "url(#paint0_linear_179_317)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0004 4.38965H109.677V23.6997C109.677 24.0338 109.406 24.3051 109.072 24.3051H83.6053C83.2713 24.3051 83 24.0338 83 23.6997V4.38965H83.0004Z",
    fill: "url(#paint1_linear_179_317)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4536 5.25977H84.5352V6.82117H85.4536V5.25977Z",
    fill: "url(#paint2_linear_179_317)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5201 5.25977H86.6016V6.82117H87.5201V5.25977Z",
    fill: "url(#paint3_linear_179_317)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3462 5.25977H88.4277V6.82117H89.3462V5.25977Z",
    fill: "url(#paint4_linear_179_317)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4126 5.25977H90.4941V6.82117H91.4126V5.25977Z",
    fill: "url(#paint5_linear_179_317)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2369 5.25977H92.3184V6.82117H93.2369V5.25977Z",
    fill: "url(#paint6_linear_179_317)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3033 5.25977H94.3848V6.82117H95.3033V5.25977Z",
    fill: "url(#paint7_linear_179_317)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1294 5.25977H96.2109V6.82117H97.1294V5.25977Z",
    fill: "url(#paint8_linear_179_317)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1958 5.25977H98.2773V6.82117H99.1958V5.25977Z",
    fill: "url(#paint9_linear_179_317)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.022 5.25977H100.104V6.82117H101.022V5.25977Z",
    fill: "url(#paint10_linear_179_317)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.088 5.25977H102.17V6.82117H103.088V5.25977Z",
    fill: "url(#paint11_linear_179_317)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.913 5.25977H103.994V6.82117H104.913V5.25977Z",
    fill: "url(#paint12_linear_179_317)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.979 5.25977H106.061V6.82117H106.979V5.25977Z",
    fill: "url(#paint13_linear_179_317)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6451 7.62988H94.873V10.402H97.6451V7.62988Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101.014 7.62988H98.2422V10.402H101.014V7.62988Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.348 7.62988H101.576V10.402H104.348V7.62988Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.657 7.62988H104.885V10.402H107.657V7.62988Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6373 11.1152H84.8652V13.8873H87.6373V11.1152Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9713 11.1152H88.1992V13.8873H90.9713V11.1152Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2799 11.1152H91.5078V13.8873H94.2799V11.1152Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6412 11.1152H94.8691V13.8873H97.6412V11.1152Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.01 11.1152H98.2383V13.8873H101.01V11.1152Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.346 11.1152H101.574V13.8873H104.346V11.1152Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M107.653 11.1152H104.881V13.8873H107.653V11.1152Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7194 14.4365H84.9473V17.2086H87.7194V14.4365Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0534 14.4365H88.2812V17.2086H91.0534V14.4365Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3619 14.4365H91.5898V17.2086H94.3619V14.4365Z",
    fill: "#003399"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7233 14.4365H94.9512V17.2086H97.7233V14.4365Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M101.092 14.4365H98.3203V17.2086H101.092V14.4365Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.428 14.4365H101.656V17.2086H104.428V14.4365Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M107.735 14.4365H104.963V17.2086H107.735V14.4365Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8014 17.7168H85.0293V20.4889H87.8014V17.7168Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1354 17.7168H88.3633V20.4889H91.1354V17.7168Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M94.444 17.7168H91.6719V20.4889H94.444V17.7168Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8053 17.7168H95.0332V20.4889H97.8053V17.7168Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M101.174 17.7168H98.4023V20.4889H101.174V17.7168Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M104.51 17.7168H101.738V20.4889H104.51V17.7168Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.817 17.7168H105.045V20.4889H107.817V17.7168Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8014 20.9893H85.0293V23.7614H87.8014V20.9893Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1354 20.9893H88.3633V23.7614H91.1354V20.9893Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M94.444 20.9893H91.6719V23.7614H94.444V20.9893Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3488 4.01758H85.1695C84.8979 4.01758 84.6758 4.23971 84.6758 4.51132V5.60824H85.0323V4.89526C85.0323 4.62365 85.2544 4.40152 85.526 4.40152H86.7053C86.7497 4.40152 86.7923 4.40802 86.8335 4.41922C86.7902 4.19131 86.589 4.01758 86.3488 4.01758Z",
    fill: "url(#paint14_linear_179_317)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6398 4.01758H87.4605C87.1889 4.01758 86.9668 4.23971 86.9668 4.51132V5.60824H87.3233V4.89526C87.3233 4.62365 87.5454 4.40152 87.817 4.40152H88.9963C89.0407 4.40152 89.0833 4.40802 89.1245 4.41922C89.0812 4.19131 88.88 4.01758 88.6398 4.01758Z",
    fill: "url(#paint15_linear_179_317)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5441 4.01758H89.3648C89.0932 4.01758 88.8711 4.23971 88.8711 4.51132V5.60824H89.2276V4.89526C89.2276 4.62365 89.4497 4.40152 89.7213 4.40152H90.9006C90.945 4.40152 90.9876 4.40802 91.0288 4.41922C90.9855 4.19131 90.7843 4.01758 90.5441 4.01758Z",
    fill: "url(#paint16_linear_179_317)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M92.505 4.01758H91.3258C91.0542 4.01758 90.832 4.23971 90.832 4.51132V5.60824H91.1885V4.89526C91.1885 4.62365 91.4107 4.40152 91.6823 4.40152H92.8615C92.906 4.40152 92.9486 4.40802 92.9898 4.41922C92.9464 4.19131 92.7452 4.01758 92.505 4.01758Z",
    fill: "url(#paint17_linear_179_317)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3195 4.01758H93.1402C92.8686 4.01758 92.6465 4.23971 92.6465 4.51132V5.60824H93.003V4.89526C93.003 4.62365 93.2251 4.40152 93.4967 4.40152H94.676C94.7204 4.40152 94.763 4.40802 94.8042 4.41922C94.7609 4.19131 94.5597 4.01758 94.3195 4.01758Z",
    fill: "url(#paint18_linear_179_317)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2804 4.01758H95.1012C94.8295 4.01758 94.6074 4.23971 94.6074 4.51132V5.60824H94.9639V4.89526C94.9639 4.62365 95.186 4.40152 95.4577 4.40152H96.6369C96.6813 4.40152 96.724 4.40802 96.7651 4.41922C96.7218 4.19131 96.5206 4.01758 96.2804 4.01758Z",
    fill: "url(#paint19_linear_179_317)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1847 4.01758H97.0055C96.7339 4.01758 96.5117 4.23971 96.5117 4.51132V5.60824H96.8682V4.89526C96.8682 4.62365 97.0903 4.40152 97.362 4.40152H98.5412C98.5856 4.40152 98.6283 4.40802 98.6694 4.41922C98.6261 4.19131 98.4249 4.01758 98.1847 4.01758Z",
    fill: "url(#paint20_linear_179_317)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M100.312 4.01758H99.1324C98.8608 4.01758 98.6387 4.23971 98.6387 4.51132V5.60824H98.9952V4.89526C98.9952 4.62365 99.2173 4.40152 99.4889 4.40152H100.668C100.713 4.40152 100.755 4.40802 100.796 4.41922C100.753 4.19131 100.552 4.01758 100.312 4.01758Z",
    fill: "url(#paint21_linear_179_317)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M102.144 4H100.964C100.693 4 100.471 4.22213 100.471 4.49374V5.59066H100.827V4.87768C100.827 4.60607 101.049 4.38394 101.321 4.38394H102.5C102.545 4.38394 102.587 4.39044 102.628 4.40164C102.585 4.17373 102.384 4 102.144 4Z",
    fill: "url(#paint22_linear_179_317)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M104.048 4H102.869C102.597 4 102.375 4.22213 102.375 4.49374V5.59066H102.731V4.87768C102.731 4.60607 102.954 4.38394 103.225 4.38394H104.405C104.449 4.38394 104.492 4.39044 104.533 4.40164C104.489 4.17373 104.288 4 104.048 4Z",
    fill: "url(#paint23_linear_179_317)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M107.82 4.04395H106.64C106.369 4.04395 106.146 4.26607 106.146 4.53769V5.63461H106.503V4.92163C106.503 4.65001 106.725 4.42789 106.997 4.42789H108.176C108.22 4.42789 108.263 4.43439 108.304 4.44558C108.261 4.21768 108.06 4.04395 107.82 4.04395Z",
    fill: "url(#paint24_linear_179_317)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M106.175 4H104.996C104.724 4 104.502 4.22213 104.502 4.49374V5.59066H104.858V4.87768C104.858 4.60607 105.081 4.38394 105.352 4.38394H106.531C106.576 4.38394 106.619 4.39044 106.66 4.40164C106.616 4.17373 106.415 4 106.175 4Z",
    fill: "url(#paint25_linear_179_317)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9382 17.9751C56.2112 20.2863 54.8513 21.1376 53.7457 20.7898C52.6152 20.4344 52.0669 18.964 52.7178 16.8518C53.3704 14.7768 54.6819 13.6878 55.9247 14.0786C57.2044 14.4809 57.5591 16.0015 56.9386 17.9751H56.9382ZM52.3223 25.4032L60.5714 15.5399L61.4411 15.8134L53.192 25.6766L52.3223 25.4032ZM53.9068 17.1516C53.4965 18.4128 53.5402 19.4462 54.1491 19.6376C54.7581 19.829 55.332 19.0456 55.751 17.7128C56.1331 16.4982 56.1924 15.4417 55.5336 15.2347C54.9123 15.0393 54.294 15.9199 53.9068 17.1516ZM61.072 24.2803C60.3507 26.5745 58.9977 27.4468 57.8795 27.095C56.7612 26.7432 56.201 25.2696 56.8692 23.144C57.5165 21.086 58.8334 19.98 60.0636 20.3668C61.3432 20.7692 61.6929 22.3068 61.072 24.2803V24.2803ZM58.0406 23.4568C57.6357 24.7011 57.674 25.7514 58.2826 25.9428C58.9038 26.1382 59.4654 25.3508 59.8844 24.0181C60.2716 22.7864 60.3254 21.7469 59.667 21.54C59.0457 21.3446 58.4274 22.2255 58.0402 23.4568H58.0406Z",
    fill: "#0095DF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3758 20.8102H47V19.6891H48.3758V17.6689H49.4427V19.6891H50.8185V20.8102H49.4427V22.8032H48.3758V20.8102Z",
    fill: "#0095DF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4161 99.4098C33.4165 99.3726 33.4142 99.3354 33.4047 99.2974C32.8447 97.0779 30.0661 95.6953 30.0661 95.6953L28.9648 95.7816C28.3317 97.7379 28.4132 98.9377 28.5149 99.4723C28.5177 99.4874 28.5224 99.5016 28.5264 99.5159C29.4345 99.597 31.3043 99.65 33.4161 99.4098V99.4098Z",
    fill: "url(#paint26_linear_179_317)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5254 99.5152C28.5745 99.6937 28.7062 99.8326 28.8748 99.8682C30.1668 100.14 32.2205 99.9212 33.0827 99.8084C33.2731 99.7835 33.412 99.6078 33.4151 99.4092C31.3033 99.6494 29.4335 99.5967 28.5254 99.5152V99.5152Z",
    fill: "url(#paint27_linear_179_317)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5215 94.1416L28.988 96.3868C29.0221 96.5515 29.1487 96.6745 29.3018 96.6888C29.4894 96.7062 29.7561 96.7169 30.0244 96.6773C30.265 96.6421 30.4323 96.3975 30.39 96.1352L30.0659 94.1416H28.5219H28.5215Z",
    fill: "url(#paint28_linear_179_317)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1844 99.487C36.9684 99.453 36.3392 99.3097 36.0139 99.1768C36.0132 99.2978 36.014 99.4209 36.0179 99.5483C36.0223 99.6845 36.1228 99.7933 36.247 99.7925L42.9242 99.7493C43.1375 99.7482 43.2617 99.5008 43.1695 99.3054C42.2942 99.3778 40.0644 99.5396 38.1844 99.487Z",
    fill: "url(#paint29_linear_179_317)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1692 99.3059C43.1613 99.2889 43.1542 99.2714 43.1427 99.2556C42.5531 98.4318 41.051 96.7908 38.0832 96.0793L36.6595 96.0342C36.6595 96.0342 36.0255 97.1362 36.0137 99.1773C36.3389 99.3102 36.9677 99.4535 38.1841 99.4875C40.0641 99.5401 42.2939 99.3783 43.1692 99.3059Z",
    fill: "url(#paint30_linear_179_317)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M36.332 93.9424C36.3546 94.0473 36.6506 95.6448 36.7653 96.2641C36.7926 96.4113 36.9074 96.5193 37.0439 96.5268C37.2877 96.5406 37.681 96.5422 38.0189 96.4504C38.2013 96.401 38.324 96.215 38.311 96.0084L38.1515 93.4814L36.332 93.942V93.9424Z",
    fill: "url(#paint31_linear_179_317)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2539 64.4469C35.2539 64.4469 37.2122 77.9048 38.6257 93.9195C38.6522 94.2178 38.4144 94.4774 38.1216 94.5391C37.6899 94.6301 37.0551 94.7382 36.5296 94.7231C36.2491 94.7152 36.0148 94.5075 35.9673 94.2305C35.4858 91.4067 32.0503 76.2528 31.1484 72.9174C31.1484 72.9174 30.1125 87.0848 30.4437 94.4351C30.452 94.6179 30.3182 94.7762 30.1362 94.7975C29.8604 94.8296 29.4196 94.8537 28.8581 94.794C28.6452 94.7714 28.4731 94.6104 28.4426 94.3983C28.0995 92.0086 26.1257 77.7841 26.2096 67.5373C26.2144 66.9596 26.8875 62.2119 26.8875 62.2119L35.2535 64.4473L35.2539 64.4469Z",
    fill: "url(#paint32_linear_179_317)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M52.041 51.5805C52.041 51.5805 51.4926 50.1374 50.8523 50.2696C50.2121 50.4017 49.5113 50.8936 49.5113 50.8936L48.4824 52.2849C48.4824 52.2849 51.3703 53.4226 52.3861 52.7704C52.3861 52.7704 55.3361 53.2801 59.0612 52.6687C58.5219 51.5303 58.2006 50.3903 58.0118 49.5059C56.1251 50.5739 54.0927 51.3716 52.041 51.5802V51.5805Z",
    fill: "url(#paint33_linear_179_317)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6666 41.1123C67.6666 41.1123 63.4432 46.4318 58.0117 49.5064C58.2005 50.3912 58.5218 51.5309 59.0611 52.6693C61.8786 52.2071 65.1396 51.1035 67.904 48.6517L67.6666 41.1123Z",
    fill: "url(#paint34_linear_179_317)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0137 41.8154L36.276 48.8578C37.0207 49.1142 37.7298 49.3133 38.4049 49.4625C38.8271 48.1028 39.7571 46.4341 40.5188 45.1932C37.7207 44.2043 36.0137 41.8158 36.0137 41.8158V41.8154Z",
    fill: "url(#paint35_linear_179_317)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9815 41.6963C46.1435 45.8401 43.0372 46.0839 40.5182 45.1935C39.7568 46.4345 38.8265 48.1032 38.4043 49.4628C48.6535 51.7223 51.0669 42.3001 51.0669 42.3001L49.9815 41.6963V41.6963Z",
    fill: "url(#paint36_linear_179_317)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7598 41.2556C50.7598 41.2556 51.2018 40.7808 52.0201 40.93C52.8384 41.0791 53.5665 41.3633 54.0766 40.93C54.5862 40.4967 54.7655 41.0783 54.7655 41.0783L53.2389 42.239L50.7598 41.2556V41.2556Z",
    fill: "url(#paint37_linear_179_317)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8457 42.0673C49.8457 42.0673 50.1488 40.8007 51.0617 40.9744C51.9746 41.1481 54.0469 42.2751 54.5811 42.0673C55.1153 41.8596 55.7983 41.3626 56.1485 41.5383L55.5312 42.3055C55.5312 42.3055 57.118 41.3903 57.391 41.9526L54.7509 43.4384C54.7509 43.4384 50.8884 43.0518 49.8457 42.0673V42.0673Z",
    fill: "url(#paint38_linear_179_317)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5935 65.2232C26.3921 65.1515 26.2516 64.9691 26.2298 64.7566C25.9694 62.23 24.7083 46.5628 32.6695 40.1184C32.6695 40.1184 33.1262 38.9237 36.8787 41.8603C40.6316 44.7964 38.6222 47.8742 37.7239 52.1193C36.6369 57.256 34.7292 61.4552 35.5732 64.6161C35.6314 64.8342 35.5167 65.0633 35.3049 65.1412C32.3898 66.2156 29.4861 66.2512 26.5939 65.2235L26.5935 65.2232Z",
    fill: "url(#paint39_linear_179_317)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7752 35.4238C35.7729 35.6466 32.5938 40.162 32.5938 40.162C32.5938 40.162 33.1644 41.2858 35.8884 42.1983L38.2397 37.3636L35.7752 35.4238Z",
    fill: "url(#paint40_linear_179_317)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5234 50.9268C34.5234 50.9268 40.5548 55.978 47.0677 53.7739C47.4717 53.6374 47.9133 53.667 48.2905 53.8661L50.1629 54.855C50.9488 55.2701 51.9222 54.9974 52.3781 54.2349C52.6381 53.7996 52.8601 53.3026 52.9044 52.8266L49.2405 51.3435L49.5108 50.8943C49.5108 50.8943 47.7222 50.7428 47.2537 52.0249C47.2537 52.0249 43.8467 53.4419 38.1006 47.1221C38.1006 47.1221 35.4933 49.3392 34.5234 50.9272V50.9268Z",
    fill: "url(#paint41_linear_179_317)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2008 50.8747C34.181 50.8747 34.1608 50.8692 34.143 50.8569C31.6033 49.1412 30.4087 46.3716 30.3968 46.3439C30.3747 46.2913 30.3992 46.2307 30.4514 46.2086C30.5041 46.186 30.5646 46.2106 30.5868 46.2632C30.5982 46.2905 31.7707 49.005 34.2581 50.686C34.3052 50.718 34.3179 50.7822 34.2858 50.8292C34.2661 50.8585 34.2332 50.8747 34.2004 50.8747H34.2008Z",
    fill: "url(#paint42_linear_179_317)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9834 47.0352C37.9494 47.0352 37.9161 47.0186 37.8963 46.9877C37.8888 46.9759 37.1128 45.7682 35.6353 43.1221C35.181 42.3085 34.5835 41.7933 33.8601 41.5907C32.6623 41.2559 31.5077 41.8982 31.4962 41.9045C31.4463 41.9318 31.3838 41.9156 31.3553 41.8657C31.3272 41.8162 31.3442 41.7533 31.3941 41.7248C31.444 41.6967 32.6315 41.0324 33.914 41.3913C34.6931 41.6085 35.333 42.1569 35.8153 43.0208C37.2893 45.6601 38.0621 46.8635 38.0701 46.8754C38.1009 46.9232 38.0871 46.9869 38.0392 47.0178C38.0218 47.0289 38.0024 47.0344 37.9834 47.0344V47.0352Z",
    fill: "url(#paint43_linear_179_317)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2769 32.8369C38.2769 32.8369 39.4082 35.4355 39.4838 36.7991C39.5597 38.1631 39.8538 39.0479 38.2769 39.3225C36.7 39.5972 35.3716 38.8117 34.6518 37.4532C34.6518 37.4532 33.524 35.3599 33.7773 34.5024C34.0301 33.6453 38.2769 32.8369 38.2769 32.8369V32.8369Z",
    fill: "url(#paint44_linear_179_317)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M35.191 36.4758L35.2808 36.4362C35.3952 36.3859 35.4438 36.2498 35.3865 36.139C35.1641 35.7093 34.7304 34.7248 35.2907 34.4952C36.0125 34.1993 38.8714 33.6164 39.488 32.6018C40.0807 31.6268 39.5556 30.3684 38.7662 30.0103C38.7132 29.9862 38.651 30.0056 38.6241 30.0566L38.5584 30.1813C38.5133 30.2663 38.3875 30.2537 38.3606 30.1611C38.3349 30.072 38.2165 30.055 38.1675 30.1334C37.9779 30.4369 37.4659 30.9287 36.0971 31.1816C34.1519 31.5405 32.8654 32.328 32.8334 33.6722C32.8314 33.7576 32.7404 33.8051 32.6676 33.7604C32.5239 33.673 32.294 33.6318 31.9869 33.8902C31.4527 34.3393 31.6712 35.5047 32.8425 36.4635C32.8983 36.509 32.8975 36.596 32.8373 36.6352C32.6248 36.7733 32.3087 37.1022 33.1286 37.5406C33.977 37.9941 34.6105 37.9569 34.8542 37.9165C34.9148 37.9066 34.9539 37.8477 34.9409 37.7875L34.6805 36.6059C34.6659 36.5391 34.7165 36.4758 34.785 36.4758H35.1906H35.191Z",
    fill: "url(#paint45_linear_179_317)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2394 36.7252C35.2394 36.7252 34.8081 35.0652 34.0637 35.5305C33.3194 35.9959 34.4499 37.3904 35.0483 37.4525L35.2394 36.7252V36.7252Z",
    fill: "url(#paint46_linear_179_317)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M48.291 53.8654C48.291 53.8654 49.8236 55.3647 50.1196 55.1463C50.2248 55.0687 50.4904 54.7866 50.748 54.4724C50.9296 54.2508 50.9486 53.9378 50.7927 53.6972L50.4314 53.1393C50.0867 52.6078 49.3495 52.4962 48.8715 52.9121C48.6305 53.1219 48.4117 53.4258 48.291 53.8654Z",
    fill: "url(#paint47_linear_179_317)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9337 64.6905C72.1078 60.7671 71.2816 58.4958 68.516 51.0592C67.6458 48.719 66.8552 46.3511 67.2375 43.8839L67.6664 41.1128C67.6664 41.1128 73.0409 39.2941 78.9987 41.036C78.9987 41.036 87.1269 44.5669 81.606 62.0061C79.1174 64.7903 76.205 65.5836 72.9337 64.6905V64.6905Z",
    fill: "url(#paint48_linear_179_317)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M68.582 37.5749L69.9757 40.923C70.0636 41.1343 70.2539 41.2851 70.4798 41.3238C71.2835 41.4615 73.2268 41.6768 74.503 40.8375C74.6549 40.7374 74.6937 40.5308 74.5896 40.3813L72.0148 36.6846L68.582 37.5745V37.5749Z",
    fill: "url(#paint49_linear_179_317)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0198 53.3109C71.8279 53.3615 71.7325 53.5772 71.8243 53.7533L75.8562 61.4842C75.9242 61.6148 76.075 61.6793 76.2162 61.6385L89.4047 57.8306C89.569 57.7831 89.6635 57.6118 89.616 57.4476L87.3443 49.5829C87.2976 49.4215 87.1306 49.3269 86.968 49.3696L72.0194 53.3113L72.0198 53.3109Z",
    fill: "url(#paint50_linear_179_317)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M72.87 52.4022C72.6812 52.4473 72.574 52.6471 72.6413 52.8292L75.8686 61.596C75.9272 61.7555 76.0993 61.8426 76.2624 61.7955L89.4113 57.9991C89.5751 57.952 89.674 57.7858 89.638 57.6196L87.8158 49.1816C87.7774 49.0039 87.6009 48.8927 87.4241 48.9346L72.87 52.4018V52.4022Z",
    fill: "url(#paint51_linear_179_317)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0162 51.5172C73.7855 51.5524 73.6336 51.776 73.6862 52.0035L75.8784 61.468C75.9303 61.6916 76.159 61.8261 76.3794 61.7624L89.3289 58.0234C89.537 57.9632 89.6597 57.7488 89.6055 57.5386L87.6139 49.8133C87.5625 49.6142 87.3689 49.4864 87.166 49.5173L74.0158 51.5172H74.0162Z",
    fill: "url(#paint52_linear_179_317)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4987 55.1256C85.5038 47.5332 79.6529 41.6953 79.6529 41.6953L76.1719 45.7537C78.8148 49.0479 80.0712 52.0668 80.6449 54.4375C81.4059 54.2159 83.2384 53.8657 84.4987 55.1256V55.1256Z",
    fill: "url(#paint53_linear_179_317)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6433 54.6531C80.546 54.6531 80.4578 54.587 80.434 54.4881C79.7265 51.5654 78.2355 48.672 76.0025 45.8886C75.9281 45.7956 75.9428 45.6599 76.0357 45.5855C76.1283 45.5111 76.2645 45.5258 76.3389 45.6188C78.6118 48.452 80.1309 51.4024 80.8535 54.3868C80.8816 54.5028 80.8103 54.6191 80.6948 54.6472C80.6778 54.6515 80.6608 54.6531 80.6437 54.6531H80.6433Z",
    fill: "url(#paint54_linear_179_317)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6444 54.4382C81.1779 56.6419 81.1217 58.2861 81.0406 59.0708C81.0101 59.3668 80.7723 59.5978 80.4755 59.6184C80.1383 59.6422 79.6793 59.673 79.2694 59.6968C78.8187 59.7229 78.3185 59.438 77.9837 59.1998C77.8128 59.0783 77.592 59.2674 77.6873 59.4542C77.937 59.9429 78.5706 60.3774 79.0074 60.6334C79.1661 60.7264 79.1364 60.9638 78.9595 61.0141L77.0918 61.5435C80.1609 64.435 82.1873 61.1997 82.1873 61.1997C83.5422 59.1064 84.2426 57.0594 84.4982 55.126C83.2379 53.866 81.4054 54.2162 80.6444 54.4378V54.4382Z",
    fill: "url(#paint55_linear_179_317)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0251 32.4531C69.9665 32.5081 67.5547 37.2443 67.5547 37.2443L70.2882 38.564L73.241 34.415C73.241 34.415 71.0048 31.5311 70.0251 32.4535V32.4531Z",
    fill: "url(#paint56_linear_179_317)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M71.998 34.9122L70.6348 37.1848C70.6143 37.2192 70.5893 37.2505 70.5601 37.2778C70.3978 37.4289 69.8426 37.8682 69.4133 37.2698C69.0473 36.7602 68.7042 36.2964 68.3362 36.1053C68.1213 35.9937 67.857 36.0827 67.7482 36.2988C67.5234 36.744 67.0885 37.6513 66.8151 38.512C66.7466 38.7276 66.8578 38.9591 67.0676 39.0442C67.6211 39.2686 68.7149 39.6742 69.6855 39.8079C69.845 39.8301 70.0029 39.7628 70.0979 39.6326C70.5153 39.0604 71.6926 37.4618 72.0942 37.0613C72.4674 36.6893 73.1563 36.8298 73.4665 36.9189C73.5844 36.9529 73.7099 36.9363 73.8147 36.8733C74.1297 36.6838 74.6794 36.2113 74.1764 35.4116C74.0514 35.2126 74.1151 34.9478 74.3114 34.8188C74.6631 34.5874 75.0446 34.1533 74.6809 33.4505C74.3129 32.7386 73.6557 32.6749 73.2081 32.7295C73.0103 32.7537 72.8092 32.65 72.7333 32.4656C72.6996 32.3837 72.6328 32.3136 72.5081 32.2883C72.2735 32.2408 72.1195 32.0263 72.1654 31.7913C72.2442 31.3885 72.1848 30.8653 71.5418 30.512C70.3626 29.8634 69.3294 30.92 69.0667 31.8119C68.8039 32.7038 70.1228 33.3342 70.9522 33.4394C71.5616 33.5166 71.8956 34.1818 72.0301 34.5292C72.0788 34.6554 72.0669 34.7963 71.9973 34.9122H71.998Z",
    fill: "url(#paint57_linear_179_317)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M71.582 37.8969C71.582 37.8969 72.1063 36.3623 72.7779 36.4185C73.449 36.4747 73.9776 37.1434 73.1455 37.8953C72.1107 38.8303 71.582 37.8965 71.582 37.8965V37.8969Z",
    fill: "url(#paint58_linear_179_317)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4052 99.2666C73.7032 99.379 75.9563 99.561 77.7323 99.6394C78.7999 99.6864 79.4144 99.582 79.7686 99.4403C79.7678 99.4803 79.767 99.5179 79.7654 99.5531C79.7571 99.7399 79.6051 99.8894 79.4164 99.9001C76.0604 100.087 73.3913 99.965 72.4413 99.9072C72.2446 99.8954 72.1279 99.6817 72.228 99.5143C72.2782 99.4304 72.3392 99.3485 72.4052 99.2674V99.2666Z",
    fill: "url(#paint59_linear_179_317)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7313 99.6384C75.9554 99.5601 73.7022 99.3781 72.4043 99.2657C73.6804 97.6999 77.7313 96.6445 77.7313 96.6445H78.8753C79.6623 97.7786 79.7759 98.8589 79.7676 99.439C79.4134 99.5807 78.7989 99.6851 77.7313 99.638V99.6384Z",
    fill: "url(#paint60_linear_179_317)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0684 94.7773L78.9612 96.896C78.9497 97.1255 78.778 97.3182 78.5481 97.351C78.3194 97.3839 78.0135 97.3878 77.6886 97.2798C77.4888 97.2133 77.3404 97.0451 77.3036 96.8398L76.9336 94.7773H79.068H79.0684Z",
    fill: "url(#paint61_linear_179_317)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9291 99.6223C94.4921 99.5439 94.7466 99.2515 94.8534 98.9385C94.8542 98.9412 94.855 98.944 94.8554 98.9468C94.9381 99.2764 94.7462 99.6183 94.3624 99.7809C93.8982 99.9772 93.3913 100.011 92.9972 99.9946C92.5746 99.9772 92.1868 99.8023 91.9739 99.5225L91.9707 99.5182C92.3949 99.7279 92.99 99.7528 93.9291 99.6219V99.6223Z",
    fill: "url(#paint62_linear_179_317)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2759 94.7631H92.2192C93.6565 94.7338 94.5591 97.7649 94.8543 98.9386C94.7474 99.2512 94.4926 99.5436 93.9299 99.6224C92.9913 99.7533 92.3957 99.7284 91.9715 99.5187C91.1952 98.497 90.8101 97.0004 90.6249 96.1271C90.4144 95.1339 91.2755 94.7627 91.2755 94.7627L91.2759 94.7631Z",
    fill: "url(#paint63_linear_179_317)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0981 92.7969L92.622 94.8807C92.6861 95.1363 92.5638 95.4002 92.3276 95.5217C92.0344 95.6721 91.622 95.83 91.2426 95.7845C91.0641 95.7631 90.9161 95.6373 90.8571 95.4695L90.0879 93.2773L92.0977 92.7973L92.0981 92.7969Z",
    fill: "url(#paint64_linear_179_317)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7228 93.3995C92.071 93.9776 89.9508 94.054 89.9508 94.054C82.3137 75.7241 79.1295 70.6781 79.1295 70.6781C80.2323 77.5966 79.3673 95.3555 79.3673 95.3555C78.107 95.9115 76.4822 95.3555 76.4822 95.3555C76.3797 84.0288 74.785 71.8581 72.7285 64.0702C77.8905 63.9542 80.6957 62.8288 81.5919 62.1201C85.8949 69.0568 92.7228 93.3995 92.7228 93.3995V93.3995Z",
    fill: "url(#paint65_linear_179_317)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_317",
    x1: 104.311,
    y1: 12.3261,
    x2: 94.3776,
    y2: 44.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_179_317",
    x1: 104.311,
    y1: 11.313,
    x2: 96.4793,
    y2: 40.0889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_317",
    x1: 84.5713,
    y1: 6.98985,
    x2: 88.838,
    y2: -2.58049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_179_317",
    x1: 86.2949,
    y1: 7.75845,
    x2: 90.5616,
    y2: -1.81189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_179_317",
    x1: 87.818,
    y1: 8.43748,
    x2: 92.0851,
    y2: -1.13289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_179_317",
    x1: 89.5421,
    y1: 9.20573,
    x2: 93.8088,
    y2: -0.364255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_179_317",
    x1: 91.0636,
    y1: 9.88476,
    x2: 95.3303,
    y2: 0.314384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_179_317",
    x1: 92.7876,
    y1: 10.6534,
    x2: 97.0543,
    y2: 1.08302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_179_317",
    x1: 94.3111,
    y1: 11.3324,
    x2: 98.5778,
    y2: 1.76202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_179_317",
    x1: 96.0347,
    y1: 12.1006,
    x2: 100.301,
    y2: 2.53065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_179_317",
    x1: 97.5582,
    y1: 12.7797,
    x2: 101.825,
    y2: 3.20929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_179_317",
    x1: 99.2819,
    y1: 13.5483,
    x2: 103.549,
    y2: 3.97793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_179_317",
    x1: 100.803,
    y1: 14.2273,
    x2: 105.07,
    y2: 4.65693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_179_317",
    x1: 102.527,
    y1: 14.9955,
    x2: 106.794,
    y2: 5.42556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_179_317",
    x1: 113.004,
    y1: 2.58006,
    x2: 66.9343,
    y2: 6.2656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_179_317",
    x1: 113.019,
    y1: 2.7621,
    x2: 66.9492,
    y2: 6.44764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_179_317",
    x1: 113.032,
    y1: 2.91343,
    x2: 66.9616,
    y2: 6.59898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_179_317",
    x1: 113.044,
    y1: 3.06947,
    x2: 66.9732,
    y2: 6.75501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_179_317",
    x1: 113.056,
    y1: 3.21358,
    x2: 66.9857,
    y2: 6.89912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_179_317",
    x1: 113.068,
    y1: 3.36925,
    x2: 66.9976,
    y2: 7.05479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_179_317",
    x1: 113.08,
    y1: 3.52059,
    x2: 67.0097,
    y2: 7.20649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_179_317",
    x1: 113.094,
    y1: 3.68962,
    x2: 67.0241,
    y2: 7.37516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_179_317",
    x1: 113.103,
    y1: 3.81796,
    x2: 67.0328,
    y2: 7.5035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_179_317",
    x1: 113.115,
    y1: 3.9693,
    x2: 67.0452,
    y2: 7.65484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_179_317",
    x1: 113.143,
    y1: 4.31267,
    x2: 67.0734,
    y2: 7.99821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_179_317",
    x1: 113.129,
    y1: 4.13833,
    x2: 67.0593,
    y2: 7.82388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E57A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_179_317",
    x1: 49.5214,
    y1: 38.3705,
    x2: 44.41,
    y2: 54.8841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_179_317",
    x1: 30.9566,
    y1: 100.393,
    x2: 31.2186,
    y2: 82.5689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_179_317",
    x1: 29.8269,
    y1: 91.981,
    x2: 28.8772,
    y2: 100.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_179_317",
    x1: 39.5892,
    y1: 100.52,
    x2: 39.8515,
    y2: 82.6959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_179_317",
    x1: 57.4724,
    y1: 40.832,
    x2: 52.3611,
    y2: 57.3456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_179_317",
    x1: 37.4396,
    y1: 92.8566,
    x2: 37.0139,
    y2: 101.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_179_317",
    x1: 36.4762,
    y1: 85.1514,
    x2: -17.6441,
    y2: 18.7638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_179_317",
    x1: 48.4828,
    y1: 51.2391,
    x2: 59.0616,
    y2: 51.2391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_179_317",
    x1: 58.2464,
    y1: 44.8875,
    x2: 69.7736,
    y2: 52.8227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175CE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_179_317",
    x1: 39.6125,
    y1: 44.4738,
    x2: 34.3023,
    y2: 53.0555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_179_317",
    x1: 55.0481,
    y1: 41.1043,
    x2: 38.4518,
    y2: 49.3603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_179_317",
    x1: 54.8051,
    y1: 39.0333,
    x2: 52.3572,
    y2: 41.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_179_317",
    x1: 55.126,
    y1: 41.006,
    x2: 38.5301,
    y2: 49.2616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_179_317",
    x1: 36.4418,
    y1: 48.9489,
    x2: 17.1757,
    y2: 75.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_179_317",
    x1: 33.6151,
    y1: 43.6822,
    x2: 35.8203,
    y2: 37.6604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_179_317",
    x1: 44.5419,
    y1: 50.6854,
    x2: 28.1466,
    y2: 79.1735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_179_317",
    x1: 33.516,
    y1: 47.8252,
    x2: 30.8612,
    y2: 53.9242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_179_317",
    x1: 36.7297,
    y1: 43.2841,
    x2: 34.2006,
    y2: 51.4217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_179_317",
    x1: 39.0343,
    y1: 34.6492,
    x2: 25.8948,
    y2: 45.1141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_179_317",
    x1: 33.9619,
    y1: 31.2061,
    x2: 39.9846,
    y2: 38.9596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_179_317",
    x1: 37.7114,
    y1: 34.0755,
    x2: 31.2451,
    y2: 39.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_179_317",
    x1: 48.291,
    y1: 53.9137,
    x2: 50.8979,
    y2: 53.9137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_179_317",
    x1: 67.5275,
    y1: 48.3688,
    x2: 89.4595,
    y2: 60.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175CE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_179_317",
    x1: 72.1529,
    y1: 40.6579,
    x2: 70.4565,
    y2: 35.5687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_179_317",
    x1: 71.7887,
    y1: 55.5047,
    x2: 89.6283,
    y2: 55.5047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BFFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_179_317",
    x1: 72.6207,
    y1: 55.3672,
    x2: 89.6452,
    y2: 55.3672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CFFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BFFFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_179_317",
    x1: 81.4017,
    y1: 53.6758,
    x2: 85.0208,
    y2: 69.9045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_179_317",
    x1: 76.3722,
    y1: 46.0824,
    x2: 87.9207,
    y2: 51.9212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175CE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_179_317",
    x1: 76.0714,
    y1: 48.5156,
    x2: 83.1662,
    y2: 51.5857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175CE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_179_317",
    x1: 82.4524,
    y1: 55.4821,
    x2: 76.9395,
    y2: 66.0843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_179_317",
    x1: 70.8054,
    y1: 33.3509,
    x2: 69.1117,
    y2: 43.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_179_317",
    x1: 72.5861,
    y1: 38.0691,
    x2: 67.5938,
    y2: 32.7658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_179_317",
    x1: 72.274,
    y1: 44.2319,
    x2: 72.5756,
    y2: 37.2314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_179_317",
    x1: 75.9801,
    y1: 85.8403,
    x2: 75.9801,
    y2: 101.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_179_317",
    x1: 72.579,
    y1: 97.6261,
    x2: 75.1685,
    y2: 102.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175CE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_179_317",
    x1: 79.0684,
    y1: 96.0745,
    x2: 76.934,
    y2: 96.0745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_179_317",
    x1: 93.4226,
    y1: 85.8394,
    x2: 93.4226,
    y2: 101.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_179_317",
    x1: 90.6929,
    y1: 96.3764,
    x2: 95.6343,
    y2: 99.8053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175CE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_179_317",
    x1: 92.639,
    y1: 94.2946,
    x2: 90.0883,
    y2: 94.2946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_179_317",
    x1: 105.704,
    y1: 19.0554,
    x2: 77.3959,
    y2: 92.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#4DB9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcession);
export default __webpack_public_path__ + "static/media/Concession.3c5d41da478e4d632942963be0edc5e8.svg";
export { ForwardRef as ReactComponent };